import * as React from 'react';
import {useContext, useEffect, useState} from "react";
import './theme-switch.css'
import {useUserInfo} from "../../hooks/useUserInfo";
import {PrimeReactContext} from "primereact/api";

interface Props {
}

export const ThemeSwitch: React.FC<Props> = (props) => {
    const {userInfo: {theme}, handleThemeChange} = useUserInfo();
    const [checked, setChecked] = useState<boolean>(theme === "light")
    const {changeTheme} = useContext(PrimeReactContext);

    const handleChangeTheme = () => {
        handleThemeChange(theme === "light" ? "dark" : "light");
    }

    useEffect(() => {
        if (!changeTheme) return;

        if (theme === 'light') {
            changeTheme('bootstrap4-dark-blue', 'saga-orange', 'theme-link');
        } else {
            changeTheme('saga-orange', 'bootstrap4-dark-blue', 'theme-link');
        }
    }, [theme]);

    useEffect(() => {
        setChecked(theme === "light");
    }, [theme])

    return <>
        <div className={'switch'}>
            <input type="checkbox" checked={checked} onChange={handleChangeTheme} className={'switch__input'}
                   id="Switch"/>
            <label className={'switch__label'} htmlFor="Switch">
                <span className={'switch__indicator'}></span>
                <span className={'switch__decoration'}></span>
            </label>
        </div>
    </>
};
